var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M256 0h384v480H256z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#060",
  d: "M0 0h256v480H0z"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#ff0",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.6
}, /*#__PURE__*/React.createElement("path", {
  d: "M339.5 306.2c-32.3-1-180-93.2-181-108l8.1-13.5c14.7 21.3 165.7 111 180.6 107.8l-7.7 13.7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.9 182.8c-2.9 7.8 38.6 33.4 88.4 63.8 49.9 30.3 92.9 49 96 46.4l1.5-2.8c-.6 1-2 1.3-4.3.6-13.5-3.9-48.6-20-92.1-46.4-43.6-26.4-81.4-50.7-87.3-61a6.3 6.3 0 01-.6-3.1h-.2l-1.2 2.2-.2.3zm175.3 123.8c-.5 1-1.6 1-3.5.8-12-1.3-48.6-19.1-91.9-45-50.4-30.2-92-57.6-87.4-64.8l1.2-2.2.2.1c-4 12.2 82.1 61.4 87.2 64.6 49.8 30.8 91.8 48.9 95.5 44.2l-1.3 2.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256.2 207.2c32.2-.3 72-4.4 95-13.6l-5-8c-13.5 7.5-53.5 12.5-90.3 13.2-43.4-.4-74.1-4.5-89.5-14.8l-4.6 8.6c28.2 12 57.2 14.5 94.4 14.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.5 193.8c-.8 1.3-15.8 6.4-37.8 10.2a381.2 381.2 0 01-58.6 4.3 416.1 416.1 0 01-56.2-3.6c-23.1-3.6-35-8.6-39.5-10.4l1.1-2.2c12.7 5 24.7 8 38.7 10.2A411.5 411.5 0 00256 206a391.8 391.8 0 0058.3-4.3c22.5-3.7 34.8-8.4 36.6-10.5l1.6 2.7zm-4.4-8.1c-2.4 2-14.6 6.3-36 9.7a388.2 388.2 0 01-55.8 4c-22 0-40.1-1.6-53.8-3.6-21.8-2.8-33.4-8-37.6-9.4l1.3-2.2c3.3 1.7 14.4 6.2 36.5 9.3a385 385 0 0053.6 3.4 384 384 0 0055.4-4c21.5-3 33.1-8.4 34.9-9.8l1.5 2.6zM150.3 246c19.8 10.7 63.9 16 105.6 16.4 38 .1 87.4-5.8 105.9-15.6l-.5-10.7c-5.8 9-58.8 17.7-105.8 17.4-47-.4-90.7-7.6-105.3-17v9.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362.8 244.5v2.5c-2.8 3.4-20.2 8.4-42 12a434 434 0 01-65.4 4.4 400 400 0 01-62-4.3 155 155 0 01-44.4-12v-2.9c9.7 6.4 35.9 11.2 44.7 12.6 15.8 2.4 36.1 4.2 61.7 4.2 26.9 0 48.4-1.9 65-4.4 15.7-2.3 38-8.2 42.4-12.1zm0-9v2.5c-2.8 3.3-20.2 8.3-42 11.9a434 434 0 01-65.4 4.5 414 414 0 01-62-4.3 155 155 0 01-44.4-12v-3c9.7 6.5 36 11.2 44.7 12.6a408 408 0 0061.7 4.3c26.9 0 48.5-2 65-4.5 15.7-2.2 38-8.1 42.4-12zm-107 68.8c-45.6-.2-84.7-12.4-93-14.4l6 9.4a249.8 249.8 0 0087.4 14.3c34.7-1 65-3.7 86.3-14.1l6.2-9.8c-14.5 6.9-64 14.6-93 14.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M344.9 297.3a143 143 0 01-2.8 4c-10 3.6-26 7.4-32.6 8.4a295.5 295.5 0 01-53.7 5c-40.4-.6-73.5-8.5-89-15.3l-1.3-2.1.2-.4 2.1.9a286.5 286.5 0 0088.2 14.5c18.8 0 37.5-2.1 52.6-4.8 23.2-4.7 32.6-8.2 35.5-9.8l.7-.4zm5.3-8.8a287.2 287.2 0 01-2 3.5c-5.4 2-20 6.2-41.3 9.2-14 1.9-22.7 3.8-50.6 4.3a347.4 347.4 0 01-94.2-14L161 289a390 390 0 0095.4 14c25.5-.5 36.4-2.4 50.3-4.3 24.8-3.8 37.3-8 41-9.1a2.9 2.9 0 000-.2l2.6-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M350.8 237.6c.1 30-15.3 57-27.6 68.8a99.3 99.3 0 01-67.8 28.2c-30.3.5-58.8-19.2-66.5-27.9a101 101 0 01-27.5-67.4c1.8-32.8 14.7-55.6 33.3-71.3a99.6 99.6 0 0164.2-22.7 98.2 98.2 0 0171 35.6c12.5 15.2 18 31.7 20.9 56.7zM255.6 135a106 106 0 01106 105.2 105.6 105.6 0 11-211.4 0c-.1-58 47.3-105.2 105.4-105.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.9 134.5c58.2 0 105.6 47.4 105.6 105.6S314.1 345.7 256 345.7s-105.6-47.4-105.6-105.6c0-58.2 47.4-105.6 105.6-105.6zM152.6 240c0 56.8 46.7 103.3 103.3 103.3 56.6 0 103.3-46.5 103.3-103.3s-46.7-103.3-103.3-103.3S152.6 183.2 152.6 240z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 143.3a97 97 0 0196.7 96.7 97.1 97.1 0 01-96.7 96.8c-53 0-96.7-43.6-96.7-96.8a97.1 97.1 0 0196.7-96.7zM161.6 240c0 52 42.6 94.4 94.4 94.4s94.4-42.5 94.4-94.4c0-52-42.6-94.4-94.4-94.4a94.8 94.8 0 00-94.4 94.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.3 134h-9.1v212.3h9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.3 132.8h2.3v214.7h-2.2V132.8zm-9 0h2.4v214.7h-2.3V132.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M361.6 244.2v-7.8l-6.4-6-36.3-9.6-52.2-5.3-63 3.2-44.8 10.6-9 6.7v7.9l22.9-10.3 54.4-8.5h52.3l38.4 4.2 26.6 6.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 223.8c24.9 0 49 2.3 68.3 6 19.8 4 33.7 9 38.5 14.5v2.8c-5.8-7-24.5-12-39-15-19-3.6-43-6-67.9-6-26.1 0-50.5 2.6-69.3 6.2-15 3-35.1 9-37.6 14.8v-2.9c1.3-4 16.3-10 37.3-14.3 18.9-3.7 43.3-6.1 69.6-6.1zm0-9.1a383 383 0 0168.3 6c19.8 4 33.7 9 38.5 14.6v2.7c-5.8-6.9-24.5-12-39-14.9-19-3.7-43-6-67.9-6a376 376 0 00-69.2 6.2c-14.5 2.7-35.4 8.9-37.7 14.7v-2.8c1.4-4 16.6-10.3 37.3-14.3 19-3.7 43.3-6.2 69.7-6.2zm-.6-46.2c39.3-.2 73.6 5.5 89.3 13.5l5.7 10c-13.6-7.4-50.6-15-94.9-14-36.1.3-74.7 4-94 14.4l6.8-11.4c15.9-8.3 53.3-12.5 87.1-12.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 176.7a354 354 0 0161.3 4.3c16 3 31.3 7.4 33.5 9.8l1.7 3c-5.3-3.4-18.6-7.3-35.6-10.5s-38.7-4.3-61-4.2c-25.3-.1-45 1.2-61.8 4.2a108.9 108.9 0 00-33.3 10.3l1.7-3.1c6-3 15.3-6.7 31.1-9.6 17.5-3.2 37.4-4.1 62.4-4.2zm0-9c21.4-.2 42.6 1 59.1 4a96 96 0 0130.6 10l2.5 4c-4.2-4.7-20-9.2-34.1-11.6-16.4-2.9-36.7-4-58.1-4.2a361 361 0 00-59.5 4.4 97.3 97.3 0 00-29.6 9.1l2.2-3.3c5.8-3 15.2-5.8 27-8.1a357 357 0 0159.9-4.4zM308.4 284a276.4 276.4 0 00-52.5-4c-65.5.8-86.6 13.5-89.2 17.3l-5-8c16.8-12 52.4-18.8 94.6-18.2 21.9.4 40.8 1.9 56.6 5l-4.5 8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.6 278.9c18.2.3 36 1 53.3 4.2l-1.2 2.2c-16-3-33.2-4-52-4-24.3-.2-48.7 2.1-70 8.2-6.7 1.9-17.8 6.2-19 9.8l-1.2-2c.4-2.2 7-6.6 19.6-10 24.4-7 47.2-8.3 70.5-8.4zm.8-9.2a327 327 0 0157.3 5l-1.3 2.3a299 299 0 00-56-4.9c-24.2 0-49.9 1.8-73.3 8.6-7.5 2.2-20.6 7-21 10.7l-1.2-2.2c.2-3.4 11.5-7.9 21.7-10.8 23.5-6.9 49.3-8.6 73.8-8.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.4 290.5l-7.8 12.3-22.7-20.1-58.6-39.5-66.2-36.3-34.3-11.7 7.3-13.6 2.5-1.3 21.3 5.3 70.4 36.3 40.6 25.6L336 272l13.9 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.6 195.5c6-4 50.2 15.6 96.6 43.6 46.1 28 90.3 59.6 86.3 65.5l-1.3 2.1-.6.5c.1-.1.8-1 0-3.1-2-6.5-33.4-31.5-85.3-62.9-50.7-30.1-92.9-48.3-97-43.1l1.3-2.6zM351 290.4c3.8-7.6-37.2-38.5-88.1-68.6-52-29.5-89.6-46.9-96.5-41.7L165 183c0 .1 0-.2.4-.5 1.2-1 3.3-1 4.2-1 11.8.2 45.5 15.7 92.8 42.8 20.8 12 87.6 55 87.3 67 0 1 .1 1.2-.3 1.8l1.7-2.6z"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 26.7) scale(1.06667)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.7,
  d: "M180.6 211a58.7 58.7 0 0017.5 41.7 59 59 0 0041.8 17.6 59.4 59.4 0 0042-17.4 59 59 0 0017.4-41.8v-79.2l-118.7-.2V211z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "red",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M182.8 211.1a56.4 56.4 0 0016.8 40 57 57 0 0040.2 16.8 56.9 56.9 0 0040.2-16.6 56.4 56.4 0 0016.7-40v-77H183v76.8m91-53.7v48.9l-.1 5.1a33.2 33.2 0 01-10 24 34 34 0 01-24 10c-9.4 0-17.7-4-23.9-10.2a34 34 0 01-10-24v-54l68 .2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "e"
}, /*#__PURE__*/React.createElement("g", {
  id: "d",
  fill: "#ff0",
  stroke: "#000",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M190.2 154.4c.1-5.5 4-6.8 4-6.8.1 0 4.3 1.4 4.3 6.9h-8.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.8 147.7l-.7 6.3h4.2c0-5.2 4-6 4-6 .1 0 4 1.1 4.1 6h4.2l-.8-6.4h-15zm-1 6.4h17c.3 0 .6.3.6.7 0 .5-.3.8-.6.8h-17c-.3 0-.6-.3-.6-.8 0-.4.3-.7.7-.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M192 154c0-3.3 2.3-4.2 2.3-4.2s2.3 1 2.3 4.2H192m-5.8-9h16.3c.3 0 .6.4.6.8 0 .3-.3.6-.6.6h-16.3c-.3 0-.6-.3-.6-.7 0-.3.3-.6.6-.6zm.4 1.5H202c.3 0 .6.3.6.7 0 .4-.3.7-.6.7h-15.5c-.4 0-.6-.3-.6-.7 0-.4.2-.7.6-.7zm5-10.6h1.2v.8h.9v-.8h1.3v.9h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.4c-.3 0-.6-.2-.6-.5v-2zm4.6 2.7l.3 6.4h-4.3l.3-6.5h3.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M191 141.6v3.4h-4v-3.4h4z"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: 10.6,
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "M186.3 139h1.2v1h.9v-1h1.2v1h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.3a.6.6 0 01-.6-.6v-2z"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: 10.6,
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  stroke: "none",
  d: "M193.9 140.6c0-.6.9-.6.9 0v1.6h-.9v-1.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  fill: "#000",
  stroke: "none",
  d: "M188.6 142.8c0-.6.8-.6.8 0v1.2h-.8v-1.2"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: 10.6,
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  y: 46.3,
  xlinkHref: "#d"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "rotate(-45.2 312.8 180)",
  xlinkHref: "#d"
})), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: 45.7,
  xlinkHref: "#d"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "matrix(-1 0 0 1 479.8 0)",
  xlinkHref: "#e"
}), /*#__PURE__*/React.createElement("g", {
  id: "f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#039",
  d: "M232.6 202.4a8.3 8.3 0 002.2 5.7 7.2 7.2 0 005.3 2.4c2.1 0 4-1 5.3-2.4a8.3 8.3 0 002.2-5.7v-10.8h-15v10.8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 236.1,
  cy: 195.7,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 244.4,
  cy: 195.7,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240.2,
  cy: 199.7,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 236.1,
  cy: 203.9,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 244.4,
  cy: 203.9,
  r: 1.5
})), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  y: -26,
  xlinkHref: "#f"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: -20.8,
  xlinkHref: "#f"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  x: 20.8,
  xlinkHref: "#f"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  y: 25.8,
  xlinkHref: "#f"
}));
function SvgPortugalFlags(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icon-css-pt",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugalFlags);
export default __webpack_public_path__ + "static/media/portugal_flags.b89a5b80ca1a71c3b96a85fe858b62da.svg";
export { ForwardRef as ReactComponent };